/**
 * Mirrors EnumExternalConversationSource in the webapp repo. Sent alongside
 * {@link Interaction.ExternalConversationID} and never omitted when the id is present.
 *
 * The two id spaces are unrelated: an Outlook conversationId and a Gmail threadId are both opaque
 * strings, and nothing in their shape stops one colliding with the other. The server compares source
 * and id together, so an id sent without its source cannot be matched at all.
 */
export enum ExternalConversationSource {
  OutlookConversation = 1,
  GmailThread = 2,
}
